var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5161 3C22.1435 3 27.5161 8.37258 27.5161 15C27.5161 21.6274 22.1435 27 15.5161 27C8.8887 27 3.51611 21.6274 3.51611 15C3.51611 8.37258 8.8887 3 15.5161 3ZM23.0592 9.22407L9.74018 22.5431C11.3407 23.7705 13.3432 24.5 15.5161 24.5C20.7628 24.5 25.0161 20.2467 25.0161 15C25.0161 12.8271 24.2866 10.8246 23.0592 9.22407ZM15.5161 5.5C10.2694 5.5 6.01611 9.75329 6.01611 15C6.01611 17.1729 6.74561 19.1754 7.97305 20.7759L21.292 7.45694C19.6915 6.2295 17.689 5.5 15.5161 5.5Z",
    fill: "#97A1CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.3e68f619.svg";
export { ForwardRef as ReactComponent };